<script lang="ts">
  import { createEventDispatcher, setContext } from "svelte";
  import { DropdownRadioGroupContext, createDropdownRadioGroup } from "../dropdown-menu";

  export let value: string;
  const group = createDropdownRadioGroup(value);

  const dispatcher = createEventDispatcher<{ change: string }>();

  setContext(DropdownRadioGroupContext, group);

  const { value: internalValue } = group;

  internalValue.subscribe((_value) => {
    if (typeof _value !== "undefined" && _value !== null) {
      value = _value;
      dispatcher("change", _value);
    }
  });

  $: {
    if (typeof value !== "undefined" && value !== null && value !== $internalValue) {
      $internalValue = value;
    }
  }
</script>

<div use:group.root>
  <slot {group} />
</div>
